"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chartjs = require("chart.js");
const React = require("react");
const colors = [
    [54, 162, 235],
    [255, 99, 132],
    [255, 206, 86],
    [75, 192, 192],
    [153, 102, 255],
    [255, 159, 64]
];
/**Obtiene los colores de una gráfica */
function getChartColors(count) {
    const ret = [];
    for (var i = 0; i < count; i++) {
        ret.push(colors[i % colors.length]);
    }
    return ret;
}
function toCssColor(alpha, color) {
    return `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${alpha})`;
}
function getPieChartData(data) {
    const colorPorSerie = data.type == "bar" || data.type == "line";
    const cantColores = colorPorSerie ? data.series.length : data.series.map(x => x.values.length).reduce((a, b) => Math.max(a, b), 0);
    const colors = getChartColors(cantColores);
    const backgroundColors = colors.map(x => toCssColor(0.5, x));
    const foreColors = colors.map(x => toCssColor(1, x));
    const type = data.type == "bar" ? "bar" : data.type;
    if (data.series.map(x => x.values.length).filter(x => x != data.labels.length).length > 0) {
        throw "La cantidad de labels debe de ser igual a la cantidad de valores en todas las series";
    }
    const options = type == "bar" || type == "line" ?
        {
            legend: {
                display: false
            },
            scales: {
                yAxes: [{
                        display: true,
                        ticks: {
                            suggestedMin: 0,
                            // OR //
                            beginAtZero: true // minimum value will be 0.
                        }
                    }]
            }
        } : undefined;
    const getSeriesData = (serie, index) => {
        return {
            data: serie.values,
            backgroundColor: serie.colors || (colorPorSerie ? backgroundColors[index] : backgroundColors),
            hoverBackgroundColor: serie.colors || (colorPorSerie ? backgroundColors[index] : backgroundColors),
            pointHoverBackgroundColor: backgroundColors[0],
            pointHoverBorderColor: foreColors[0],
            pointBackgroundColor: backgroundColors[0]
        };
    };
    return ({
        responsive: true,
        type: type,
        data: {
            labels: data.labels,
            datasets: data.series.map(getSeriesData)
        },
        options: options
    });
}
/**Una gráfica que soporta varias series y varios tipos de gráficas*/
class Chart extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.onCanvasInit = (canvas) => {
            this.canvas = canvas;
            if (canvas)
                this.updateChartData(this.props);
            else
                this.destroyChart();
        };
    }
    destroyChart() {
        if (this.chart != null) {
            this.chart.destroy();
        }
        this.chart = null;
    }
    updateChartData(props) {
        const chartData = getPieChartData(props.value);
        this.destroyChart();
        this.chart = new chartjs(this.canvas, chartData);
    }
    componentWillUpdate(props) {
        this.updateChartData(props);
    }
    render() {
        return (React.createElement("div", { style: this.props.style },
            React.createElement("canvas", { ref: this.onCanvasInit })));
    }
}
exports.Chart = Chart;
/**Gráfica que soporta sólo una serie de información */
class SimpleChart extends React.PureComponent {
    render() {
        const data = {
            type: this.props.type || "doughnut",
            labels: this.props.values.map(x => x.label),
            series: [
                {
                    values: this.props.values.map(x => x.value),
                    colors: this.props.colors
                }
            ]
        };
        return (React.createElement(Chart, { value: data }));
    }
}
exports.SimpleChart = SimpleChart;
/**Una gráfica que devuelve la cantidad de elemento repetidos */
class HistogramChart extends React.PureComponent {
    render() {
        const data = new Map();
        //Acumulamos las frecuencias:
        for (const id of this.props.values) {
            data.set(id, (data.get(id) || 0) + 1);
        }
        const values = Array.from(data.keys()).sort(this.props.sort).map(key => ({ label: "" + key, value: data.get(key) }));
        return (React.createElement(SimpleChart, { type: "bar", values: values }));
    }
}
exports.HistogramChart = HistogramChart;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/chart.js
// module id = 2204
// module chunks = 0